import React from "react";
import SEO from "@/components/SEO";
import { RESTAURANT } from "@/lib/restaurant";

export default function MentionsLegales() {
  return (
    <div data-testid="mentions-legales-page" className="pt-32 pb-20">
      <SEO
        title="Mentions légales"
        description={`Mentions légales du restaurant ${RESTAURANT.name} à Trappes. SIRET, dirigeant, hébergement, propriété intellectuelle.`}
        path="/mentions-legales"
      />
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="eyebrow">Informações legais</div>
        <h1 className="text-5xl md:text-6xl mt-3 mb-10">Mentions <em className="italic text-[#C04E38]">légales</em></h1>

        <article className="prose prose-lg max-w-none space-y-8">
          <section>
            <h2 className="text-2xl mb-3">1. Éditeur du site</h2>
            <ul className="text-[#5C5A56] space-y-1.5">
              <li><b className="text-[#2C2B29]">Raison sociale :</b> {RESTAURANT.legalName}</li>
              <li><b className="text-[#2C2B29]">Forme juridique :</b> {RESTAURANT.legal.legalForm}</li>
              <li><b className="text-[#2C2B29]">Siège social :</b> {RESTAURANT.legal.legalAddress}</li>
              <li><b className="text-[#2C2B29]">Adresse de visite :</b> {RESTAURANT.fullAddress}</li>
              <li><b className="text-[#2C2B29]">SIREN :</b> {RESTAURANT.legal.siren}</li>
              <li><b className="text-[#2C2B29]">SIRET :</b> {RESTAURANT.legal.siret}</li>
              <li><b className="text-[#2C2B29]">N° TVA intracommunautaire :</b> {RESTAURANT.legal.vat}</li>
              <li><b className="text-[#2C2B29]">Code APE / NAF :</b> {RESTAURANT.legal.apeCode} — {RESTAURANT.legal.apeLabel}</li>
              <li><b className="text-[#2C2B29]">Date de création :</b> {RESTAURANT.legal.creationDate}</li>
              <li><b className="text-[#2C2B29]">Convention collective :</b> {RESTAURANT.legal.collectiveAgreement}</li>
              <li><b className="text-[#2C2B29]">{RESTAURANT.legal.directorTitle} :</b> {RESTAURANT.legal.director}</li>
              <li><b className="text-[#2C2B29]">Directeur de la publication :</b> {RESTAURANT.legal.director}</li>
              <li><b className="text-[#2C2B29]">Téléphone :</b> <a href={`tel:${RESTAURANT.phone.replace(/\s/g,"")}`} className="text-[#C04E38]">{RESTAURANT.phone}</a></li>
              <li><b className="text-[#2C2B29]">Email :</b> <a href={`mailto:${RESTAURANT.email}`} className="text-[#C04E38]">{RESTAURANT.email}</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl mb-3">2. Hébergement</h2>
            <p className="text-[#5C5A56] leading-relaxed">
              Ce site est hébergé sur l'infrastructure cloud d'<b>Emergent</b> (kubernetes / cloud public).
              Pour toute question relative à l'hébergement, contactez l'éditeur.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3">3. Propriété intellectuelle</h2>
            <p className="text-[#5C5A56] leading-relaxed">
              L'ensemble des éléments du site (textes, photographies, logos, vidéos, charte graphique)
              est la propriété exclusive de {RESTAURANT.legalName} ou de ses partenaires. Toute
              reproduction, représentation, modification ou exploitation, totale ou partielle,
              sans autorisation écrite préalable, est interdite et constitue une contrefaçon
              sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3">4. Données personnelles</h2>
            <p className="text-[#5C5A56] leading-relaxed">
              Conformément au RGPD et à la loi Informatique et Libertés, vous disposez d'un
              droit d'accès, de rectification, de suppression et d'opposition aux données
              vous concernant. Pour exercer ce droit, écrivez à <a href={`mailto:${RESTAURANT.email}`} className="text-[#C04E38]">{RESTAURANT.email}</a>.
              Voir notre <a href="/confidentialite" className="text-[#C04E38] underline">politique de confidentialité</a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3">5. Cookies</h2>
            <p className="text-[#5C5A56] leading-relaxed">
              Le site utilise uniquement des cookies techniques nécessaires au bon fonctionnement
              (session admin). Aucun cookie publicitaire ou de traçage tiers n'est déposé sans
              votre consentement explicite.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3">6. Crédits & sources</h2>
            <p className="text-[#5C5A56] leading-relaxed">
              Informations légales : <a href="https://www.societe.com/societe/globo-dancing-100171859.html" target="_blank" rel="noopener noreferrer" className="text-[#C04E38]">societe.com</a>,
              INSEE / Registre national des entreprises (RNE).
              Conception : {RESTAURANT.name}.
            </p>
          </section>

          <section>
            <h2 className="text-2xl mb-3">7. Médiateur de la consommation</h2>
            <p className="text-[#5C5A56] leading-relaxed">
              Conformément à l'article L.612-1 du Code de la consommation, le client peut
              recourir gratuitement au service de médiation MEDICYS — <a href="https://medicys.fr" target="_blank" rel="noopener noreferrer" className="text-[#C04E38]">medicys.fr</a>.
            </p>
          </section>
        </article>
      </div>
    </div>
  );
}
